import type { JobDuration, JobState, JobWorkPlace } from '../../../../shared/source/data-contract/job';
import type { LearningOpportunityType } from '../../../../shared/source/data-contract/learning-opportunities';
import type { LearningOpportunityState } from '../../../../shared/source/data-contract/learning-opportunities';
import type { JobSeekingStatus, RelocationPreference } from '../../../../shared/source/data-contract/user';
import type { TranslationKey } from '../../../../shared/source/internationalization/translation';
import type { TranslationResource } from '../../../../shared/source/internationalization/translation';

export const relocationPreferenceMap: Record<RelocationPreference, TranslationKey> = {
    'not open': 'common.enums.relocation-preference.not open',
    open: 'common.enums.relocation-preference.open',
    'relocation only': 'common.enums.relocation-preference.relocation only',
};

export const jobSeekingStatusMap: Record<JobSeekingStatus, TranslationKey> = {
    'not open': 'common.enums.job-seeking-status.not open',
    open: 'common.enums.job-seeking-status.open',
};

export const jobStateMap: Record<JobState, TranslationKey> = {
    archived: 'common.enums.job-state.archived',
    draft: 'common.enums.job-state.draft',
    hired: 'common.enums.job-state.hired',
    published: 'common.enums.job-state.published',
};

export const jobDurationMap: Record<JobDuration, TranslationKey> = {
    'fixed-term': 'common.enums.duration.fixed-term',
    permanent: 'common.enums.duration.permanent',
};

export const jobWorkPlaceMap: Record<JobWorkPlace, TranslationKey> = {
    'on-site': 'common.enums.work-place.on-site',
    remote: 'common.enums.work-place.remote',
};

export const learningOpportunityStateMap: Record<LearningOpportunityState, TranslationKey> = {
    all: 'pages.learning-opportunities.states.all',
    archived: 'pages.learning-opportunities.states.archived',
    draft: 'pages.learning-opportunities.states.draft',
    published: 'pages.learning-opportunities.states.published',
};

export const typesMap: Record<LearningOpportunityType, TranslationKey> = {
    course: 'pages.learning-opportunities.types.course',
};

export const languagesMap: Record<keyof TranslationResource['common']['languages'], TranslationKey> = {
    'de-DE': 'common.languages.de-DE',
    'en-US': 'common.languages.en-US',
    'es-ES': 'common.languages.es-ES',
    'fr-FR': 'common.languages.fr-FR',
};

export const stateMap: Record<string, TranslationKey> = {
    active: 'states.active',
    all: 'states.all',
    archived: 'states.archived',
    draft: 'states.draft',
    published: 'states.published',
};
